
document.addEventListener('DOMContentLoaded', function () {
  initializeSlickSliders();
  initializeAccordion();
});

window.addEventListener('load', function () {
  $('.sb-slider').each(function () {
    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('setPosition');
    }
  });
});

window.addEventListener('resize', function () {
  $('.sb-slider').each(function () {
    if ($(this).hasClass('slick-initialized')) {
      $(this).slick('setPosition');
    }
  });
});


function initializeSlickSliders() {
  $('.sb-dots .slick-dots').remove();

  $('.sb-slider').each(function () {
    const $slider = $(this);
    const $wrapper = $slider.closest('.sb-image-slider-wrapper');
    const $dotsContainer = $wrapper.find('.sb-dots');

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $wrapper.removeClass('slick-ready');

    const images = $slider.find('img');
    let loaded = 0;
    const total = images.length;

    if (total === 0) {
      setupSlider();
      return;
    }

    // Force all lazy images to load
    images.each(function () {
      const img = $(this);
      const src = img.attr('data-src') || img.attr('src');

      if (img.attr('data-src')) {
        img.attr('src', src);
      }

      const tempImg = new Image();
      tempImg.onload = imageLoaded;
      tempImg.onerror = imageLoaded;
      tempImg.src = src;
    });

    function imageLoaded() {
      loaded++;
      if (loaded >= total) {
        setupSlider();
      }
    }

    // Fallback timeout
    setTimeout(() => {
      if (!$wrapper.hasClass('slick-ready')) {
        setupSlider();
      }
    }, 5000);

    function setupSlider() {
        $slider.slick({
          dots: true,
          appendDots: $dotsContainer,
          vertical: true,
          verticalSwiping: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          // adaptiveHeight: true,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                vertical: true,
                verticalSwiping: true
              }
            },
            {
              breakpoint: 769,
              settings: {
                vertical: false,
                verticalSwiping: false
              }
            }
          ]
        });

        setTimeout(() => {
          $slider.slick('setPosition');
          $wrapper.addClass('slick-ready');
          enableMouseWheelScroll(); // 👈 add this line
        }, 200);
      }

  });
}


function initializeAccordion() {
  const accordionItems = document.querySelectorAll('.sb-accordion-item');
  accordionItems.forEach((item) => {
    const header = item.querySelector('.sb-accordion-header');
    const content = item.querySelector('.sb-accordion-content');

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      accordionItems.forEach((el) => {
        el.classList.remove('active');
        const elContent = el.querySelector('.sb-accordion-content');
        elContent.style.height = '0px';
      });

      if (!isOpen) {
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
      }
    });
  });
}




function enableMouseWheelScroll() {
  $('.sb-slider').each(function () {
    const $slider = $(this);

    $slider.on('wheel', function (e) {
      e.preventDefault();

      if (e.originalEvent.deltaY < 0) {
        // Scroll up → previous slide
        $slider.slick('slickPrev');
      } else {
        // Scroll down → next slide
        $slider.slick('slickNext');
      }
    });
  });
}
